<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="RedeemCodeBundleList"
          :extra-items="isShow ? [
            {
              text: form.name,
            }
          ] : isEdit ? [
            {
              text: form.name,
              to: 'RedeemCodeBundleDetail',
              params: $route.params.redeemCodeBundleId
            },
            '編輯優惠券'
          ] : [
            '新增優惠券'
          ]"
        />
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">{{ title }}</h4>
        </div>
      </div>

      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <section class="row mb-8">
          <div class="col-12 col-xl-8">
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="通路"
              label-for="merchant"
            >
              <b-form-select
                v-model="form.merchant_id"
                :options="merchants"
                :disabled="isFetchMerchants || isShow"
              ></b-form-select>
              <b-form-invalid-feedback :state="!v$.form.merchant_id.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="分店">
              <AppSingleSelect
                v-model="selected_branch"
                :options="branchOptions"
                :disabled="disabled_branch_select"
                @input="branchChange"
              ></AppSingleSelect>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="活動事件"
              label-for="event"
            >
              <b-form-select
                v-model="form.event_id"
                :options="eventOptions"
                :disabled="isFetchEvent || isShow"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="獎項名稱"
              label-for="name"
            >
              <b-form-input
                id="name"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.name"
                :state="v$.form.name.$error ? false : null"
                :disabled="isShow"
              ></b-form-input>
              <b-form-invalid-feedback :state="!v$.form.name.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="獎項描述"
              label-for="description"
            >
              <b-form-textarea
                id="description"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.description"
                :disabled="isShow"
                row="6"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label-for="img_url"
            >
              <template #label>
                圖片
                <p class="text-black-50 mt-2" style="font-size: 0.75rem">
                  寬 x 高：1400px x 700px
                </p>
              </template>
              <template #default>
                <div class="image-selector">
                  <div class="image" v-if="image || form.img_url">
                    <img
                      class="img-fluid"
                      :src="image != null ? image : form.img_url"
                    />
                    <button
                      v-if="!isShow"
                      class="btn btn-danger"
                      type="button"
                      @click="image = form.img_url = null"
                    >
                      <i class="fa fa-times m-0"></i>
                    </button>
                  </div>
                  <div class="selector" v-else>
                    <ImageSelector
                      @input="selectImage('image', $event)"
                      class="
                        border
                        h-100
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                      :aspectRatio="2 / 1"
                    >
                      <template #trigger="{ openFileSelector }">
                        <button
                          :disabled="!canClick"
                          class="btn s-trigger-btn"
                          @click="openFileSelector"
                        >
                          <i class="fa fa-plus"></i> 圖片
                        </button>
                      </template>
                      <template #content>
                        <small class="text-center mb-2">
                          建議尺寸 寬1400px 、 高 700px
                        </small>
                      </template>
                    </ImageSelector>
                  </div>
                </div>
              </template>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label-for="thumb_img_url"
            >
              <template #label>
                縮圖
                <p class="text-black-50 mt-2" style="font-size: 0.75rem">
                  寬 x 高：700px x 700px
                </p>
              </template>
              <template #default>
                <div class="image-selector thumbnail">
                  <div class="image" v-if="thumbImage || form.thumb_img_url">
                    <img
                      class="img-fluid"
                      :src="thumbImage != null ? thumbImage : form.thumb_img_url"
                    />
                    <button
                      v-if="!isShow"
                      class="btn btn-danger"
                      type="button"
                      @click="thumbImage = form.thumb_img_url = null"
                    >
                      <i class="fa fa-times m-0"></i>
                    </button>
                  </div>
                  <div class="selector" v-else>
                    <ImageSelector
                      @input="selectImage('thumbImage', $event)"
                      class="
                        border
                        h-100
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                      :aspectRatio="1 / 1"
                    >
                      <template #trigger="{ openFileSelector }">
                        <button
                          :disabled="!canClick"
                          class="btn s-trigger-btn"
                          @click="openFileSelector"
                        >
                          <i class="fa fa-plus"></i> 圖片
                        </button>
                      </template>
                      <template #content>
                        <small class="text-center mb-2">
                          建議尺寸 寬700px 、 高 700px
                        </small>
                      </template>
                    </ImageSelector>
                  </div>
                </div>
              </template>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="發布狀態"
              label-for="status"
            >
              <b-form-select
                v-model="form.status"
                :options="statusOptions"
              ></b-form-select>
              <b-form-invalid-feedback :state="!v$.form.status.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="優惠券種類"
              label-for="status"
            >
              <b-form-select
                v-model="form.target_source"
                :options="targetSourceOptions"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="折扣方式"
              v-if="showTargetDiscount"
            >
              <div class="d-flex align-items-center flex-wrap">

                <!-- Select 包裝：加入錯誤訊息 -->
                <div class="position-relative" style="flex: 0 0 15%;">
                  <b-form-select
                    v-model="form.target_discount_type"
                    :options="discountTypeOptions"
                    :state="v$.form.target_discount_type.$error ? false : null"
                  ></b-form-select>

                  <b-form-invalid-feedback
                    :state="!v$.form.target_discount_type.$error"
                    class="position-absolute"
                    style="top: 100%; left: 0;"
                  >
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>

                <div class="position-relative" style="flex: 0 0 15%;margin-left: 20px;">
                  <b-form-input
                    id="discount-input"
                    type="text"
                    v-show="form.target_discount_type === consts.DISCOUNT_TYPE.PERCENTAGE ||
                          form.target_discount_type === consts.DISCOUNT_TYPE.AMOUNT"
                    v-model.number="form.target_discount_input"
                    :state="v$.form.target_discount_input.$error ? false : null"
                    @input="onDiscountInput"
                    @blur="onDiscountBlur"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    :state="!v$.form.target_discount_input.$error"
                    class="position-absolute"
                    style="top: 100%; left: 0;"
                  >
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>

                <span id="percentage" v-show="form.target_discount_type === consts.DISCOUNT_TYPE.PERCENTAGE" class="ml-2">
                  %
                  <span class="mdi mdi-help-circle-outline"></span>
                </span>
                            <span id="amount" v-show="form.target_discount_type === consts.DISCOUNT_TYPE.AMOUNT" class="ml-2">
                  元
                  <span class="mdi mdi-help-circle-outline"></span>
                </span>
              </div>

              <!-- Tooltip 放後面, 不影響排版 -->
              <b-tooltip target="percentage" placement="bottom">
                若打 85折，請輸入 85
              </b-tooltip>
              <b-tooltip target="amount" placement="bottom">
                若折扣 125 元，請輸入 125
              </b-tooltip>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="獎項類型"
              label-for="type"
            >
              <b-form-radio-group
                v-model="form.type"
                :options="redeemCodeBundleTypes"
                :disabled="isShow || isEdit"
                :state="v$.form.type.$error ? false : null"
              ></b-form-radio-group>
              <b-form-invalid-feedback :state="!v$.form.type.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="序號"
              label-for="type"
            >
              <b-form-radio-group
                v-model="form.redeemcode_type"
                :options="redeemCodeTypes"
                :disabled="isShow || isLinePointType || isEdit"
              >
                <template #first>
                  <b-form-radio
                    v-model="form.redeemcode_type"
                    :value="consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE"
                  >
                    上傳序號包
                    <template
                      v-if="
                        form.redeemcode_type ===
                          consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE &&
                        !isShow
                      "
                    >
                      <b-button class="mx-2" v-b-modal.modal-upload>
                        上傳
                      </b-button>
                    </template>
                  </b-form-radio>
                </template>
              </b-form-radio-group>
            </b-form-group>

            <!-- 不顯示文字序號 start -->
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="不顯示文字序號"
              v-if="form.redeemcode_type === consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE
                || form.redeemcode_type === consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.FIXED
                || form.redeemcode_type === consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.RANDOM"
            >
              <b-form-checkbox
                v-model="form.is_hide_code"
                :disabled="isShow"
              >
              </b-form-checkbox>
            </b-form-group>
            <!-- 不顯示文字序號 end -->

            <!-- 固定序號設定 start -->
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="固定序號"
              label-for="static_redeem_code"
              v-if="form.redeemcode_type === 2"
            >
              <b-form-input
                id="static_redeem_code"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.static_redeem_code"
                :disabled="isShow"
                :state="v$.form.static_redeem_code.$dirty && v$.form.static_redeem_code.$invalid ? false : null"
                @blur="v$.form.static_redeem_code.$touch()"
              ></b-form-input>

              <b-form-invalid-feedback
                v-if="v$.form.static_redeem_code.$dirty && v$.form.static_redeem_code.$invalid"
              >
                <span v-if="v$.form.static_redeem_code.requiredIf.$invalid">此欄位為必填</span>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="序號張數上限"
              label-for="name"
              v-if="form.redeemcode_type == 2"
            >
              <b-form-input
                id="name"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.static_redeem_code_ceil_limit"
                placeholder="不填寫表示無限"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>
            <!-- 固定序號設定 end -->

            <!-- 隨機序號設定 start -->
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="隨機序號長度"
              label-for="random_redeem_code_length"
              v-if="form.redeemcode_type === 3"
            >
              <b-form-input
                id="random_redeem_code_length"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="number"
                v-model="form.random_redeem_code_length"
                :disabled="isShow || isEdit"
                :state="v$.form.random_redeem_code_length.$dirty && v$.form.random_redeem_code_length.$invalid ? false : null"
                @blur="v$.form.random_redeem_code_length.$touch()"
              />
              <b-form-invalid-feedback
                v-if="v$.form.random_redeem_code_length.$dirty && v$.form.random_redeem_code_length.$invalid">
                <span v-if="v$.form.random_redeem_code_length.requiredIf.$invalid">此欄位為必填</span>
                <span v-else-if="v$.form.random_redeem_code_length.minValue.$invalid">最小值需為 1</span>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="序號張數上限"
              label-for="name"
              v-if="form.redeemcode_type == 3"
            >
              <b-form-input
                id="name"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.random_redeem_code_ceil_limit"
                placeholder="不填寫表示無限"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>
            <!-- 隨機序號設定 end -->

            <!-- 不使用序號設定 start -->
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="數量張數上限"
              label-for="name"
              v-if="form.redeemcode_type == 0"
            >
              <b-form-input
                id="name"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.none_redeem_code_ceil_limit"
                placeholder="不填寫表示無限"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>
            <!-- 不使用序號設定 end -->

            <!-- 優惠券數量上限達到時的提示訊息設定 start -->
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="領券超過總數量上限時的提示文字"
              label-for="custom-limit-message"
            >
              <b-form-input
                id="custom-limit-message"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.custom_limit_message"
                placeholder="不填寫時顯示「優惠券已發完」"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>
            <!-- 優惠券數量上限達到時的提示訊息設定 end -->

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="是否顯示條碼"
              label-for="is_show_barcode"
            >
              <b-form-checkbox
                class="mb-2 mr-sm-2 mb-sm-0"
                v-model="form.is_show_barcode"
                name="is_show_button"
                :value="true"
                :unchecked-value="false"
                :disabled="
                  isShow ||
                  form.redeemcode_type ==
                    consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.NONE ||
                  isLinePointType
                "
              ></b-form-checkbox>
            </b-form-group>
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="條碼類型"
              label-for="barcode_type"
              v-if="form.is_show_barcode"
            >
              <b-form-select
                v-model="form.barcode_type"
                :options="barcodeTypes"
                disabled
              ></b-form-select>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="領取方式"
            >
              <div class="take-type-categories">
                <div
                  v-for="category in takeTypeCategories"
                  :key="category.id"
                  class="take-type-category"
                >
                  <h6 class="category-title">{{ category.title }}</h6>
                  <div class="category-options-row">
                    <template v-for="option in category.options">
                      <b-form-radio
                        :key="option.value"
                        v-model="form.take_type"
                        :value="option.value"
                        :disabled="getOptionDisabled(option)"
                        :state="v$.form.take_type.$error ? false : null"
                        v-b-tooltip.html.hover.bottom="{ customClass: 'text-left' }"
                        :title="option.tooltip"
                      >
                        {{ option.text }}
                        <!-- 點數輸入框 -->
                        <template v-if="option.value === consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT">
                          <input
                            class="reclaim-input mx-2"
                            v-model="form.point_need"
                            type="number"
                            min="0"
                            :disabled="isShow || form.take_type !== consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT"
                            placeholder="點數"
                          />
                          點
                        </template>
                        <span class="mdi mdi-help-circle-outline"></span>
                      </b-form-radio>
                    </template>
                  </div>
                </div>
              </div>
              <b-form-invalid-feedback :state="!v$.form.take_type.$error">
                此欄位為必填
              </b-form-invalid-feedback>
              <b-form-invalid-feedback :state="!v$.form.point_need.$error" v-if="form.take_type === consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT">
                兌換點數為必填，且必須大於等於 0
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="可否重複領券"
            >
              <b-form-radio-group
                v-model="form.reclaim_type"
                :state="v$.form.take_type.$error ? false : null"
                :disabled="isShow"
              >
                <!-- 這個等同於限領一次，畫面上就不用不可重複領券，但系統為了相容後端還是存在這個選項
                <b-form-radio :value="consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_DISABLED"> 不可重複領券 </b-form-radio>
                -->
                <b-form-radio :value="consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_UNLIMITED">
                  不限次數
                </b-form-radio>
                <b-form-radio
                  :value="
                    consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_LIMITED
                  "
                >
                  每人限領
                  <input
                    class="reclaim-input"
                    v-model="form.reclaim_times"
                    type="number"
                    min="1"
                    :disabled="
                      form.reclaim_type !=
                      consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES
                        .RECLAIM_TYPE_LIMITED
                    "
                  />
                  次
                </b-form-radio>
              </b-form-radio-group>
              <b-form-invalid-feedback :state="!v$.form.reclaim_type.$error">
                此欄位必填
              </b-form-invalid-feedback>
              <b-form-invalid-feedback :state="!v$.form.reclaim_times.$error">
                次數必須大於 0
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="領券次數超過上限時提示文字"
              label-for="reclaim-message"
            >
              <b-form-input
                id="reclaim-message"
                v-model="form.reclaim_message"
                :disabled="isShow"
                placeholder="不填寫時顯示「領取超過限額次數」"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="領取期限"
            >
              <div
                class="
                  d-flex
                  flex-column flex-xl-row
                  align-items-start align-items-xl-center
                "
              >
                <datepicker
                  placeholder="Select Date"
                  v-model="start_at"
                  bootstrap-styling
                  format="yyyy-MM-dd"
                  :language="zh"
                  :disabled="isShow"
                  :disabledDates="disabledDates"
                  clear-button
                ></datepicker>
                <span class="mx-2">~</span>
                <datepicker
                  placeholder="Select Date"
                  v-model="end_at"
                  bootstrap-styling
                  format="yyyy-MM-dd"
                  :language="zh"
                  :disabled="isShow"
                  :disabledDates="disabledDates"
                  clear-button
                ></datepicker>
              </div>
              <b-form-invalid-feedback
                :state="!v$.start_at.beforeEndAt.$invalid"
              >
                結束時間必須大於起始時間
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="使用方式"
            >
              <b-form-radio-group
                v-model="form.usage_type"
                :options="usageTypes"
                :state="v$.form.usage_type.$error ? false : null"
                :disabled="isShow || form.take_type == consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.SYSTEM_ASSIGN"
              >
              </b-form-radio-group>
              <b-form-invalid-feedback :state="!v$.form.usage_type.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="使用期限"
            >
              <b-form-radio-group
                v-model="form.dateline_type"
                :options="datelineTypes"
                :state="v$.form.dateline_type.$error ? false : null"
                :disabled="isShow"
              >
              </b-form-radio-group>
              <b-form-invalid-feedback :state="!v$.form.dateline_type.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              v-if="
                form.dateline_type ==
                consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.SAME_AS_TAKE_TIME
              "
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label=""
            >
              <div
                class="
                  d-flex
                  flex-column flex-xl-row
                  align-items-start align-items-xl-center
                "
              >
                <datepicker
                  placeholder="Select Date"
                  v-model="start_at"
                  bootstrap-styling
                  format="yyyy-MM-dd"
                  :language="zh"
                  :disabled="true"
                ></datepicker>
                <span class="mx-2">~</span>
                <datepicker
                  placeholder="Select Date"
                  v-model="end_at"
                  bootstrap-styling
                  format="yyyy-MM-dd"
                  :language="zh"
                  :disabled="true"
                ></datepicker>
              </div>
            </b-form-group>
            <b-form-group
              v-if="
                form.dateline_type ==
                consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.CUSTOM
              "
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label=""
            >
              <div
                class="
                  d-flex
                  flex-column flex-xl-row
                  align-items-start align-items-xl-center
                "
              >
                <datepicker
                  placeholder="Select Date"
                  v-model="used_start_at"
                  bootstrap-styling
                  format="yyyy-MM-dd"
                  :language="zh"
                  :disabled="isShow"
                  :disabledDates="disabledDates"
                ></datepicker>
                <span class="mx-2">~</span>
                <datepicker
                  placeholder="Select Date"
                  v-model="used_end_at"
                  bootstrap-styling
                  format="yyyy-MM-dd"
                  :language="zh"
                  :disabled="isShow"
                  :disabledDates="disabledDates"
                ></datepicker>
              </div>
            </b-form-group>
            <b-form-group
              v-if="
                form.dateline_type ==
                consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.BY_TAKE_DATE
              "
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
            >
              <!-- 自訂 label -->
              <template #label>
                <span id="start-day-tooltip">
                  領取後幾日可使用
                  <span
                    class="mdi mdi-help-circle-outline ml-1 align-middle"
                  ></span>
                </span>
              </template>
              <b-tooltip target="start-day-tooltip" placement="right">
                0為領取後立即可使用
              </b-tooltip>
              <b-form-input
                class="mb-2 mr-sm-2 mb-sm-0"
                type="number"
                v-model="form.start_days_after_take"
                placeholder="0為領取後立即可使用"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-if="
                form.dateline_type ==
                consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.BY_TAKE_DATE
              "
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
            >
              <!-- 自訂 label -->
              <template #label>
                <span id="start-day-tooltip-1">
                  領取後幾日內有效
                  <span
                    class="mdi mdi-help-circle-outline ml-1 align-middle"
                  ></span>
                </span>
              </template>
              <b-tooltip target="start-day-tooltip-1" placement="right">
                0 為當日需使用完畢
              </b-tooltip>
              <b-form-input
                class="mb-2 mr-sm-2 mb-sm-0"
                type="number"
                v-model="form.end_days_after_take"
                placeholder="0為領取後當日需使用完畢"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="核銷設定"
            >
              <b-form-radio-group
                v-model="form.confirm_type"
                :options="confirmTypes"
                :state="v$.form.confirm_type.$error ? false : null"
                :disabled="isShow || isLinePointType"
              >
              </b-form-radio-group>
              <b-form-invalid-feedback :state="!v$.form.confirm_type.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="是否顯示獎項按鈕"
              label-for="is_show_button"
            >
              <b-form-checkbox
                class="mb-2 mr-sm-2 mb-sm-0"
                v-model="form.is_show_button"
                name="is_show_button"
                :value="true"
                :unchecked-value="false"
                :disabled="isShow || isLinePointType"
              ></b-form-checkbox>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="按鈕文字"
              label-for="button_text"
              v-if="form.is_show_button"
            >
              <b-form-input
                id="button_text"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.button_text"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="按鈕連結"
              label-for="button_url"
              v-if="form.is_show_button && !isLinePointType"
            >
              <b-form-input
                id="button_url"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="form.button_url"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="是否以外部瀏覽器開啟"
              label-for="button_url_external"
              v-if="form.is_show_button"
            >
              <b-form-checkbox
                class="mb-2 mr-sm-2 mb-sm-0"
                v-model="form.button_url_external"
                name="button_url_external"
                :value="true"
                :unchecked-value="false"
                :disabled="isShow || isLinePointType"
              ></b-form-checkbox>
            </b-form-group>
          </div>
        </section>
      </b-overlay>

      <div class="d-flex justify-content-center mb-6 preserve-spacing-for-datetime-picker">
        <b-button class="mr-4" variant="outline-danger" @click="handleCancel">{{
            isShow ? "返回" : "取消"
          }}</b-button>
        <b-overlay
          v-if="!isShow"
          :show="isSubmmiting"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button variant="success" @click="handleSubmit">
            {{ isEdit ? "確認修改" : "確認新增" }}
          </b-button>
        </b-overlay>
      </div>
    </b-card>
    <b-modal id="modal-upload" title="上傳優惠券">
      <b-overlay :show="showLoadingUpload">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">請上傳帳號 Excel 檔案</label>
          <div class="my-3">已選擇檔案 : {{ file ? file.name : "" }}</div>
          <b-form-file class="mb-3" plain v-model="file" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
          <b-button
            size="sm"
            variant="outline-primary"
            href="/excel/event_redeem_code_list.xlsx"
            target="_blank"
          ><i class="fa fa-file-text"></i>下載範例檔案
          </b-button>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="resetFile"
        >
          取消
        </b-button>
        <b-button size="sm" variant="outline-primary" @click="cancel()">
          確認
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf, minValue } from "@vuelidate/validators";
import { format, isBefore, set, subDays } from "date-fns";
import Datepicker from "vuejs-datepicker";
import { zh } from "vuejs-datepicker/dist/locale";
import redeemCodeBundleApi from "../../../apis/redeemCodeBundle";
import merchantApi from "../../../apis/merchant";
import PermissionChecker from "@/utils/PermissionChecker";
import * as consts from "@/consts";
import myConsoleMixin from "@/mixins/Dashboard/RedeemCodeBundle/myConsole";
import ImageSelector from "@/components/ImageSelector";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import Tooltip from "@/components/Dashboard/Tooltip.vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {Tooltip, AppSingleSelect, Datepicker, ImageSelector, BreadCrumb },
  mixins: [myConsoleMixin],
  setup() {
    const v$ = useVuelidate();
    return { v$ };
  },
  data() {
    let redeemCodeBundleTypes = [
      ...Object.keys(consts.REDEEM_CODE_BUNDLE_TYPES).map((key) => {
        const value = consts.REDEEM_CODE_BUNDLE_TYPES[key];
        return {
          text: consts.REDEEM_CODE_BUNDLE_TYPE_TRANSLATE[value],
          value,
        };
      }),
    ];
    redeemCodeBundleTypes = redeemCodeBundleTypes.filter(
      (item) => item.value != consts.REDEEM_CODE_BUNDLE_TYPES.COUPON
    );

    return {
      zh,
      isLoading: false,
      isSubmmiting: false,
      isFetchMerchants: false,
      isFetchEvent: false,
      merchants: [],
      eventOptions: [
        { text: "無", value: null },
      ],
      disabledDates: { to: subDays(new Date(), 1) },
      form: {
        merchant_id: null,
        name: "",
        type: null,
        status: consts.PUBLISH_STATUS.DRAFT,
        event_id: "",
        is_show_barcode: false,
        barcode_type: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.CODE_128,
        is_show_button: false,
        is_hide_code: false,
        static_redeem_code: null,
        static_redeem_code_ceil_limit: null,
        random_redeem_code_length: null,
        random_redeem_code_ceil_limit: null,
        none_redeem_code_ceil_limit: null,
        redeemcode_type: null,
        reclaim_type: consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_UNLIMITED,
        reclaim_times: 1,
        reclaim_message: null,
        custom_limit_message: null,
        usage_type: consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.NOT_IMMEDIATE,
        branch_id: null,
        point_need: null,
        target_source: consts.TARGET_SOURCE.WALTILY,
        target_discount_type: consts.DISCOUNT_TYPE.PERCENTAGE,
        target_discount_input: 0
      },
      disabled_branch_select: true,
      selected_branch: {},
      start_at: new Date(),
      end_at: new Date(),
      redeemCodeBundleTypes,
      redeemCodeTypes: [
        {
          text: "固定序號",
          value: consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.FIXED,
        },
        {
          text: "隨機序號",
          value: consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.RANDOM,
        },
        {
          text: "不使用序號",
          value: consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.NONE,
        },
      ],
      usageTypes: [
        {
          text: "無須立即使用",
          value: consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.NOT_IMMEDIATE,
          disabled: false,
        },
        {
          text: "需立即使用",
          value: consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE,
          disabled: false,
        },
      ],
      datelineTypes: [
        {
          text: "與領取區間相同",
          value: consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.SAME_AS_TAKE_TIME,
        },
        {
          text: "自定日期區間",
          value: consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.CUSTOM,
        },
        {
          text: "依日期區間推算",
          value: consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.BY_TAKE_DATE,
        },
      ],
      confirmTypes: [
        {
          text: "使用後自動核銷",
          value: consts.REDEEM_CODE_BUNDLE_CONFIRM_TYPES.AUTO,
          disabled: false,
        },
        {
          text: "無核銷按鈕",
          value: consts.REDEEM_CODE_BUNDLE_CONFIRM_TYPES.NONE,
          disabled: false,
        },
        {
          text: "輸入店號核銷",
          value: consts.REDEEM_CODE_BUNDLE_CONFIRM_TYPES.BRANCH_CODE,
          disabled: false,
        },
      ],
      used_start_at: new Date(),
      used_end_at: new Date(),
      barcodeTypes: [
        {
          text: "Code 128",
          value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.CODE_128,
        },
        {
          text: "Code 39",
          value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.CODE_39,
        },
        {
          text: "Code 39 (顯示檢查碼)",
          value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.CODE_39_WITH_CHECKSUM,
        },
        { text: "PZN", value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.PZN },
        {
          text: "EAN-13",
          value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.EAN_13,
        },
        { text: "EAN-8", value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.EAN_8 },
        { text: "JAN", value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.JAN }, // another name for the EAN-13
        {
          text: "ISBN-13",
          value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.ISBN_13,
        },
        {
          text: "ISBN-10",
          value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.ISBN_10,
        },
        { text: "ISSN", value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.ISSN },
        { text: "UPC-A", value: consts.REDEEM_CODE_BUNDLE_BARCODE_TYPES.UPC_A },
      ],
      consts,
      showLoadingUpload: false,
      file: null,
      image: null,
      thumbImage: null,
      canClick: true,
      canUpload: true,
      targetSourceOptions:[
        { text: "一般優惠券", value: consts.TARGET_SOURCE.WALTILY }
      ],
      discountTypeOptions:[
        { text: "%折扣", value: consts.DISCOUNT_TYPE.PERCENTAGE },
        { text: "折扣金額", value: consts.DISCOUNT_TYPE.AMOUNT },
        { text: "免運", value: consts.DISCOUNT_TYPE.FREE_SHIPPING }
      ],
      showTargetDiscount: false,
    };
  },
  validations() {
    return {
      form: {
        merchant_id: { required },
        name: { required },
        type: { required },
        status: { required },
        take_type: { required },
        usage_type: { required },
        dateline_type: { required },
        confirm_type: { required },
        reclaim_type: { required },
        reclaim_times: {
          requiredIf: requiredIf(
            this.form.reclaim_type ==
            consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_LIMITED
          ),
          minValue: minValue(1),
        },
        random_redeem_code_length: {
          requiredIf: requiredIf(function () {
            return this.form.redeemcode_type == 3;
          }),
          minValue: minValue(1),
        },
        static_redeem_code: {
          requiredIf: requiredIf(() => this.form.redeemcode_type === 2),
        },
        point_need: {
          requiredIf: requiredIf(() => this.form.take_type === consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT),
          minValue: minValue(0),
        },
        target_discount_type: {
          requiredIf: requiredIf(
            () =>
              this.showTargetDiscount === true
          ),
        },
        target_discount_input: {
          requiredIf: requiredIf(function () {
            return this.form.target_discount_type === consts.DISCOUNT_TYPE.PERCENTAGE ||
              this.form.target_discount_type === consts.DISCOUNT_TYPE.AMOUNT
          }),
        },
      },
      start_at: {
        beforeEndAt: () => {
          if (!this.start_at || !this.end_at) {
            return true;
          }

          const startDate = set(new Date(this.start_at), {
            hours: 0,
            minutes: 0,
          });
          const endDate = set(new Date(this.end_at), {
            hours: 23,
            minutes: 59,
          });
          return isBefore(startDate, endDate);
        },
      },
    };
  },
  computed: {
    ...mapGetters('general', [
      'myBranches',
      'currentBranch'
    ]),
    ...mapState("general", {
      organization: (state) => state.organization,
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
    ...mapGetters("route", ["routeQuery"]),
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    redeemCodeBundleId() {
      return this.$route.params.redeemCodeBundleId || this.$route.query.copyFromId;
    },
    isEdit() {
      return ["RedeemCodeBundleEdit", "MyConsoleRedeemCodeBundleEdit"].includes(
        this.$route.name
      );
    },
    isShow() {
      return [
        "RedeemCodeBundleDetail",
        "MyConsoleRedeemCodeBundleDetail",
      ].includes(this.$route.name);
    },
    title() {
      switch (true) {
        case this.isEdit:
          return "編輯優惠券";
        case this.isShow:
          return "檢視優惠券";
        default:
          return "新增優惠券";
      }
    },
    takeTypeCategories() {
      return [
        {
          id: 'coupon',
          title: '優惠券專區',
          options: [
            {
              value: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.DIRECT,
              text: '直接領取',
              tooltip: '顯示在優惠券清單，可直接領取；亦可透過網址領券。'
            },
            {
              value: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.INPUT_CODE,
              text: '輸入序號領取',
              tooltip: '可輸入優惠券序號領券或是透過網址領券。'
            }
          ]
        },
        {
          id: 'point',
          title: '點數專區',
          options: [
            {
              value: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT,
              text: '點數兌換',
              tooltip: '顯示在點數專區，使用點數兌換。'
            }
          ]
        },
        {
          id: 'loyalty_card',
          title: '集點卡專區',
          options: [
            {
              value: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.LOYALTY_CARD_REDEEM,
              text: '集點兌換',
              tooltip: '集點卡專用'
            }
          ]
        },
        {
          id: 'others',
          title: '其他',
          options: [
            {
              value: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.URL_TAKE,
              text: '網址領取',
              tooltip: '只能透過網址領券。'
            },
            {
              value: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.SYSTEM_ASSIGN,
              text: '系統派發',
              tooltip: '於指定情境，由系統直接發券。'
            }
          ]
        }
      ];
    },
    isLinePointType() {
      return this.form.type == consts.REDEEM_CODE_BUNDLE_TYPES.LINE_POINT;
    },
    isFromCopy() {
      return !!this.$route.query.copyFromId;
    },
    branchOptions() {
      let options = [];

      if (this.checkPermission([consts.REDEEM_CODE_LIST_NO_BRANCH])) {
        options = [
          {
            value: 'null',
            text: '品牌組織階層(無隸屬分店)'
          }
        ];
      }

      if (this.checkPermission([consts.REDEEM_CODE_LIST_BRANCH]) || options.length === 0) {
        const option1 = this.myBranches.map(branch => {
          let branchName = `${branch.branch_code} ${branch.name}`;
          return {
            value: branch.id,
            text: branchName
          };
        });

        options = [
          ...options,
          ...option1 // ← 改這裡，把陣列展開
        ];
      }

      return options;
    },
    statusOptions() {
      return [
        { text: "發布", value: consts.PUBLISH_STATUS.PUBLISHED },
        { text: "草稿", value: consts.PUBLISH_STATUS.DRAFT },
        { text: "關閉", value: consts.PUBLISH_STATUS.CLOSED },
      ]
    },
  },
  watch: {
    "form.redeemcode_type"(val) {
      if (val === consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.NONE) {
        if (this.form.is_show_barcode) {
          this.form.is_show_barcode = false;
        }
        if (
          this.form.take_type == consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.INPUT_CODE
        ) {
          this.form.take_type = null;
        }

        this.form.random_redeem_code_length = null;
        this.form.random_redeem_code_ceil_limit = null;

        this.form.static_redeem_code = null;
        this.form.static_redeem_code_ceil_limit = null;
      }

      if (val == consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.FIXED) {
        this.form.random_redeem_code_length = null;
        this.form.random_redeem_code_ceil_limit = null;

        this.form.none_redeem_code_ceil_limit = null;
      }

      if (val == consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.RANDOM) {
        this.form.static_redeem_code = null;
        this.form.static_redeem_code_ceil_limit = null;

        this.form.none_redeem_code_ceil_limit = null;
      }
    },
    "form.type"(val) {
      if (val == consts.REDEEM_CODE_BUNDLE_TYPES.LINE_POINT) {
        this.form.redeemcode_type =
          consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE;
        this.form.confirm_type = consts.REDEEM_CODE_BUNDLE_CONFIRM_TYPES.NONE;
        this.form.is_show_button = true;
        this.form.button_url =
          "https://points.line.me/pointcode?pincode={$code}#/pointcode/form";
        this.form.is_show_barcode = false;
        this.form.button_url_external = false;
      }
    },
    "form.take_type"(val) {
      if (val === consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.SYSTEM_ASSIGN) {
        this.form.usage_type = consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.NOT_IMMEDIATE;
      }
    },
    "form.usage_type"(val) {
      let confirmType = this.confirmTypes.find(
        (item) => item.value == consts.REDEEM_CODE_BUNDLE_CONFIRM_TYPES.NONE
      );

      confirmType.disabled = val === consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE;
    },
    "form.confirm_type"(val) {
      let usageType = this.usageTypes.find(
        (item) => item.value == consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE
      );

      usageType.disabled = val === consts.REDEEM_CODE_BUNDLE_CONFIRM_TYPES.NONE;
    },
  },
  mounted() {
    if (
      (!this.fromMyConsole &&
        !this.checkPermission([consts.REDEEM_CODE_LIST_CREATE])) ||
      (this.fromMyConsole &&
        !this.checkPermission([consts.MY_REDEEM_CODE_LIST_VIEW]))
    ) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.$router.push({
            name: this.listRouteName,
            query: this.routeQuery,
          });
        });
      return;
    }

    // 有權限的話，可以編輯下拉
    if (this.checkPermission([consts.REDEEM_CODE_LIST_BRANCH])) {
      this.disabled_branch_select = false;
    }

    if (this.redeemCodeBundleId) {
      this.fetchRedeemCodeBundle();
    } else {
      // 有 REDEEM_CODE_LIST_NO_BRANCH 的話預設選擇 品牌組織階層(無隸屬分店)
      if (this.checkPermission([consts.REDEEM_CODE_LIST_NO_BRANCH])) {
        this.selected_branch = this.branchOptions.find(
          option => option.value === 'null'
        );
      } else {
        this.selected_branch = this.branchOptions.find(
          option => option.value === this.currentBranch.id
        );
      }
    }

    this.getMerchants();
    this.getEvents();

    const targetSourceOptions = this.getModuleConfig("coupon", "additional_target_source");
    const showAdditionalTargetSource = this.getModuleConfig("coupon", "show_additional_target_source");

    if (typeof showAdditionalTargetSource !== 'undefined' && showAdditionalTargetSource) {
      this.targetSourceOptions = [
        ...this.targetSourceOptions,
        ...targetSourceOptions.map(opt => ({
          text: opt.text,
          value: opt.key
        }))
      ];
    }

    this.showTargetDiscount = this.getModuleConfig("coupon", "show_target_discount") === true;
  },
  methods: {
    getOptionDisabled(option) {
      if (this.isShow) return true;

      // 輸入序號領取在「不使用序號」模式下停用
      if (option.value === consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.INPUT_CODE) {
        return this.form.redeemcode_type === consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.NONE;
      }

      return false;
    },
    branchChange(){
      if (this.checkPermission([consts.REDEEM_CODE_LIST_NO_BRANCH])) {
        // 有權限選擇「無隸屬分店」，允許手動選擇分店
        this.form.branch_id = this.selected_branch?.value ?? null;
      } else {
        // 沒有權限選擇「無隸屬分店」，自動套用分店
        const targetBranchId = this.redeemCodeBundleId
          ? this.form.branch_id              // 若有已儲存的 Bundle ID，使用儲存的 branch_id
          : this.currentBranch.id;           // 否則預設為目前登入的分店 ID

        this.selected_branch = this.branchOptions.find(
          option => option.value === targetBranchId
        );
        this.form.branch_id = targetBranchId;
      }
    },
    async fetchRedeemCodeBundle() {
      try {
        this.isLoading = true;
        const {data} = await redeemCodeBundleApi.getRedeemCodeBundle(
          this.redeemCodeBundleId
        );

        const {
          id,
          merchant_id,
          name,
          description,
          type,
          status,
          redeemcode_type,
          take_type,
          usage_type,
          dateline_type,
          used_start_at,
          used_end_at,
          barcode_type,
          start_at,
          end_at,
          start_days_after_take,
          end_days_after_take,
          confirm_type,
          is_show_button,
          is_show_barcode,
          is_hide_code,
          button_text,
          button_url,
          button_url_external,
          img_url,
          thumb_img_url,
          static_redeem_code,
          static_redeem_code_ceil_limit,
          reclaim_type,
          random_redeem_code_length,
          random_redeem_code_ceil_limit,
          none_redeem_code_ceil_limit,
          reclaim_times,
          reclaim_message,
          custom_limit_message,
          event_id,
          branch_id,
          point_need,
          target_source,
          target_discount_type
        } = data.data;

        if (this.isShow || this.isEdit || this.isFromCopy) {
          this.form = {
            id,
            merchant_id,
            name,
            description,
            type,
            status: status || this.form.status,
            redeemcode_type,
            take_type,
            usage_type,
            dateline_type,
            barcode_type,
            start_days_after_take,
            end_days_after_take,
            confirm_type,
            is_show_button,
            is_show_barcode,
            is_hide_code,
            button_text,
            button_url,
            button_url_external,
            img_url,
            thumb_img_url,
            static_redeem_code,
            static_redeem_code_ceil_limit,
            random_redeem_code_length,
            random_redeem_code_ceil_limit,
            none_redeem_code_ceil_limit,
            reclaim_type,
            reclaim_times,
            reclaim_message,
            custom_limit_message,
            event_id,
            branch_id,
            point_need,
            target_source,
            target_discount_type
          };
          const inputValue =
            data.data.target_discount_type === consts.DISCOUNT_TYPE.AMOUNT
              ? data.data.discount_amount
              : data.data.discount_percentage;

          this.$set(this.form, 'target_discount_input', inputValue ?? '');

          this.start_at = start_at && new Date(start_at);
          this.end_at = end_at && new Date(end_at);
          this.used_start_at = used_start_at && new Date(used_start_at);
          this.used_end_at = used_end_at && new Date(used_end_at);
          if (
            this.form.reclaim_type ==
            consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_DISABLED
          ) {
            this.form.reclaim_type =
              consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_LIMITED;
            this.form.reclaim_times = 1;
          }

          if (this.isEdit) {
            if (this.form.branch_id == null) {
              this.selected_branch = this.branchOptions.find(
                option => option.value === 'null'
              );
            } else {
              this.selected_branch = this.branchOptions.find(
                option => option.value === this.form.branch_id
              );
            }
          } else {
            // 有 REDEEM_CODE_LIST_NO_BRANCH 的話預設選擇 品牌組織階層(無隸屬分店)
            if (this.checkPermission([consts.REDEEM_CODE_LIST_NO_BRANCH])) {
              this.selected_branch = this.branchOptions.find(
                option => option.value === 'null'
              );
            } else {
              this.selected_branch = this.branchOptions.find(
                option => option.value === this.currentBranch.id
              );
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoading = false;
    },
    async handleSubmit() {
      const result = await this.v$.$validate();

      if (!result) return;

      if (!this.form.branch_id && this.selected_branch && this.selected_branch.value !== 'null') {
        this.form.branch_id = this.selected_branch.value;
      }

      // 將null轉換
      if (this.form.branch_id === 'null') {
        this.form.branch_id = null;
      }

      if (this.showTargetDiscount === false) {
        this.form.target_discount_type = null;
      }

      if (this.form.dateline_type === consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.BY_TAKE_DATE) {
        if (this.form.start_days_after_take > this.form.end_days_after_take) {
          this.$swal.fire({
            title: "領取後幾日可使用必須小於等於領取後幾日內有效",
            type: "error",
          });
          return;
        }
      }

      if (this.isEdit) {
        await this.handleUpdate();
      } else {
        await this.handleCreate();
      }
    },
    async handleUpdate() {
      try {
        this.isSubmmiting = true;
        await this.uploadImageFirst();
        this.handleFormatDates();
        await redeemCodeBundleApi.updateRedeemCodeBundle(
          this.redeemCodeBundleId,
          {
            ...this.form,
          }
        );
        if (
          this.file &&
          this.form.redeemcode_type ==
          this.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE
        ) {
          let result = await this.uploadRedeemCodeData(this.redeemCodeBundleId);
          if (!result) {
            this.isSubmmiting = false;
            return;
          }
        }
        this.showSuccessPopup("修改成功");
      } catch (error) {
        this.showErrorMessage(error);
      }
      this.isSubmmiting = false;
    },
    handleFormatDates() {
      this.form.start_at = this.doHandleFormatDates(this.start_at, 0, 0, 0);
      this.form.end_at = this.doHandleFormatDates(this.end_at, 23, 59, 59);
      this.form.used_start_at = this.doHandleFormatDates(
        this.used_start_at,
        0,
        0,
        0
      );
      this.form.used_end_at = this.doHandleFormatDates(
        this.used_end_at,
        23,
        59,
        59
      );
    },
    doHandleFormatDates(datetime, hours, minutes, seconds) {
      if (!datetime) return null;

      return format(
        set(new Date(datetime), {
          hours,
          minutes,
          seconds,
        }),
        "yyyy-MM-dd HH:mm:ss"
      );
    },
    async handleCreate() {
      try {
        this.isSubmmiting = true;
        await this.uploadImageFirst();
        this.handleFormatDates();
        const {data} = await redeemCodeBundleApi.createRedeemCodeBundle({
          fromMyConsole: this.fromMyConsole,
          ...this.form,
        });
        if (
          this.file &&
          this.form.redeemcode_type ==
          this.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE
        ) {
          console.log("create file");
          console.log(data);
          let result = await this.uploadRedeemCodeData(data.data.id);
          if (!result) {
            this.isSubmmiting = false;
            return;
          }
        }
        this.showSuccessPopup("新增成功");
      } catch (error) {
        this.showErrorMessage(error);
      }
      this.isSubmmiting = false;
    },
    async uploadImageFirst() {
      let imagePromises = [];
      if (this.image) {
        imagePromises.push(this.uploadImage('img_url', this.image));
      }
      if (this.thumbImage) {
        imagePromises.push(this.uploadImage('thumb_img_url', this.thumbImage));
      }
      await Promise.all(imagePromises);
    },
    async getEvents() {
      this.isFetchEvent = true;
      const {data} = await redeemCodeBundleApi.getEvents({is_all: true});
      this.isFetchEvent = false;

      this.eventOptions = [
        {value: "", text: "無"},
        ...data.data.map((event) => {
          return {
            value: event.id,
            text: `(${event.code}) ${event.name}`
          };
        }),
      ];
    },
    async getMerchants() {
      this.isFetchMerchants = true;
      const {data} = await merchantApi.list();
      this.isFetchMerchants = false;

      this.merchants = [
        {value: null, text: "請選擇"},
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: merchant.type_name
              ? `${merchant.name} (${merchant.type_name})`
              : merchant.name,
          };
        }),
      ];

      const defaultMerchant =
        data.data.find(
          (merchant) => merchant.type === this.defaultMerchantType
        ) ?? data.data.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE);

      if (defaultMerchant && !this.form.merchant_id) {
        this.form.merchant_id = defaultMerchant.id;
      }
    },
    handleCancel() {
      this.$router.push({name: this.listRouteName, query: this.routeQuery});
    },
    showSuccessPopup(message) {
      this.$swal
        .fire({
          type: "success",
          text: message,
        })
        .then(() => {
          this.$router.push({
            name: this.listRouteName,
            query: this.routeQuery,
          });
        });
    },
    showErrorMessage(error) {
      console.error(error);
      const {status, data} = error.response;

      let html = "未知錯誤";
      if (status && status === 422 && data.message) {
        html = Object.values(data.message)
          .map((m) => m[0])
          .join("<br/>");
      } else if (data.message) {
        html = data.message;
      }

      this.$swal.fire({
        type: "error",
        html,
      });
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },

    resetFile() {
      this.file = null;
      this.$bvModal.hide("modal-upload");
    },

    async uploadRedeemCodeData(id) {
      try {
        let formData = new FormData();
        formData.append("file", this.file);
        await redeemCodeBundleApi.imoprtRedeemCode(id, formData);
      } catch (e) {
        console.error(e);
        if (e.response.status === 422 && e.response.data.message[0]) {
          this.$swal.fire({
            title: "檔案內容有誤",
            type: "error",
            text: e.response.data.message[0] ?? null,
          });
        } else {
          this.$swal.fire({
            title: "上傳失敗",
            type: "error",
          });
        }
        return false;
      }
      return true;
    },
    selectImage(imageKey, image) {
      this[imageKey] = image;
    },
    async uploadImage(imageKey, imageBase64) {
      try {
        this.canClick = false;
        const response = await redeemCodeBundleApi.uploadImageByBase64(
          imageBase64
        );
        this.form[imageKey] = response.data.img_url;
      } catch (err) {
        throw new Error("上傳圖片失敗");
      } finally {
        this.canClick = true;
      }
    },
    onDiscountInput(value) {
      // 僅保留數字（清除任何非數字）
      const cleanValue = String(value).replace(/\D/g, '');

      // 更新 v-model
      this.$set(this.form, 'target_discount_input', cleanValue ? parseInt(cleanValue, 10) : '');
    },
    onDiscountBlur() {
      const value = String(this.form.target_discount_input || '')
      const cleanValue = value.replace(/\D/g, '')

      // 改為新變數，強制 Vue 更新
      this.$set(this.form, 'target_discount_input', cleanValue ? String(parseInt(cleanValue, 10)) : '');

      this.$forceUpdate()
    }
  },
};
</script>

<style scoped lang="scss">
.reclaim-input {
  width: 5rem;
  border: 1px solid;
}

.text-left::v-deep .tooltip-inner {
  text-align: left;
}

.take-type-categories {
  .take-type-category {
    margin-bottom: 1.5rem;
    padding: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    background-color: #f9f9f9;

    .category-title {
      margin-bottom: 0.75rem;
      font-weight: bold;
      color: #495057;
      border-bottom: 1px solid #dee2e6;
      padding-bottom: 0.5rem;
    }

    .category-options-row {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      align-items: center;

      .custom-radio {
        margin-right: 0;
        margin-bottom: 0;
      }
    }
  }
}

.image-selector {
  .image {
    position: relative;
    width: 30%;
    max-width: 200px;
    max-height: 100px;

    button {
      position: absolute;
      top: -1rem;
      right: -1rem;
    }
  }

  .selector {
    width: 200px;
    height: 100px;
  }

  &.thumbnail {
    .image {
      max-width: 100px;
      max-height: 100px;
    }

    .selector {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
